import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { HashLink } from "react-router-hash-link";
import { useProductContext } from "../../../context/ProductContext";
import { useTranslation } from "react-i18next";
import CurrencyFormat from "react-currency-format";

const FeaturedProductRecent = ({ width = 9, currentLocation }) => {
  const { products } = useProductContext();
  const { t, i18n } = useTranslation();

  return (
    <Box
      sx={{
        width: width / 10,
        ml: "auto",
        mr: "auto",
        mb: 10,
        mt: 5,
      }}
    >
      <Box
        sx={{
          textAlign: "left",
          pl: 6,
          fontSize: "17px",
        }}
      >
        {t("Heslet's Best Sellers")}
        {/* <Box
          sx={{
            borderBottom: "5px solid #f3756d",
            width: "40px",
            paddingBottom: "20px",
          }}
        ></Box> */}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid
          container
          sx={{
            mt: 4,
          }}
        >
          {products?.map((pro, idx) => {
            if (idx < 4) {
              return (
                <Grid
                  item
                  xs={12}
                  md={3}
                  sm={6}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <HashLink to={"/product/" + pro.linkTo + "#top"}>
                    <Box
                      sx={{
                        padding: "20px",
                        backgroundColor: "#f8f7f5",
                        // border: "1px solid black",
                      }}
                    >
                      <img
                        src={pro.img}
                        className="animation"
                        width="130"
                        height="130"
                      />
                    </Box>

                    <Box sx={{ pt: 1, color: "#757575" }}>It's All Good</Box>
                    <Box
                      sx={{
                        mt: 1,
                        fontSize: "11px",
                        height: "30px",
                        // border: "1px solid black",
                        minWidth: "230px",
                        maxWidth: "230px",
                      }}
                    >
                      {t(pro.title)}
                    </Box>
                    <Box sx={{ mt: 1, fontSize: "16px", fontWeight: 600 }}>
                      {currentLocation === "KO" ? (
                        <CurrencyFormat
                          value={pro.price_KO}
                          displayType={"text"}
                          thousandSeparator={true}
                          suffix={"원"}
                        />
                      ) : (
                        <CurrencyFormat
                          decimalScale={2}
                          value={pro.price_US}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      )}
                    </Box>
                  </HashLink>
                </Grid>
              );
            }
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default FeaturedProductRecent;
